module.exports = __webpack_public_path__ + "img/sld_scb_24_t1_b1_green.d17c71f6.svg";